import { useState } from "react";

const FloatingInput = ({
  id,
  type = "text",
  label,
  value,
  onChange,
  onBlur,
  error,
  min,
  max,
  maxLength,
  inputMode = "text",
  pattern,
  className = "",
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const handleChange = (e) => {
    let newValue = e.target.value;

    // Clean non-numeric characters for number inputs
    if (type === "number") {
      newValue = newValue.replace(/[^0-9]/g, "");
    }

    // Apply maxLength restriction
    if (maxLength && newValue.length > maxLength) {
      newValue = newValue.slice(0, maxLength);
    }

    onChange({ ...e, target: { ...e.target, value: newValue } });
  };

  const handleKeyPress = (e) => {
    if (type === "number") {
      // Only allow numeric input
      if (
        !/[0-9]/.test(e.key) &&
        !["Backspace", "Tab", "Enter", "Delete"].includes(e.key)
      ) {
        e.preventDefault();
      }
    }
  };

  const hasValue = value !== "" && value !== undefined;

  return (
    <div className={`relative mb-0.5 ${className}`}>
      <input
        id={id}
        type={type === "number" ? "text" : type}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        placeholder={label}
        inputMode={inputMode}
        pattern={pattern}
        min={min}
        max={max}
        className={`
          w-full h-[calc(3.75rem+2px)] md:h-[calc(4.2rem+2px)]
          pt-[1.15rem] md:pt-[2.03rem] pb-[0.15rem] md:pb-[0.73rem] px-3.5 md:px-[0.85rem]
          border-2 rounded-xl md:rounded-[14px]
          text-base bg-white
          transition-[border-color] duration-200
          placeholder:text-transparent
          focus:outline-none focus:border-green
          ${
            error
              ? "border-red shadow-[0_0_0_0.2rem_rgba(220,53,69,0.25)] animate-shake"
              : "border-light-gray"
          }
        `}
      />
      <label
        htmlFor={id}
        className={`
          absolute top-0 left-0 h-full
          px-4 md:px-[0.95rem] py-[1.1rem] md:py-[1.3rem]
          pointer-events-none
          transition-all duration-100 ease-in-out
          text-base
          origin-top-left
          ${
            isFocused || hasValue
              ? "scale-75 -translate-y-[0.3rem] md:-translate-y-[0.5rem] translate-x-[0.1rem] md:translate-x-[0.15rem] font-medium"
              : ""
          }
          ${isFocused ? "text-green" : error ? "text-red" : "text-gray"}
        `}
      >
        {label}
      </label>
    </div>
  );
};

export default FloatingInput;
